export {default} from '../../../core/components/Repository/FieldTextJoin';